import { createSelector } from '@reduxjs/toolkit';

import { selectReadyBusinessTypes } from 'shared/selectors/jsonQuery';

import { EJsonQueryReadyBusinessType } from '../../../../packages/api-models/common/json_query';
import { IReadyBusinessGroupItemSchema } from 'shared/repositories/announcements/entities/v1_get_business_possible_appointments/ReadyBusinessGroupItemSchema';

import { selectBusinessAppointmentsRaw } from './selectBusinessAppointmentsRaw';

const RENTAL_GROUP_TYPE = 'rentalBusiness';
const RENTAL_GROUP_NAME = 'Арендный бизнес';

export const selectBusinessAppointmentsGroups = createSelector(
  [selectBusinessAppointmentsRaw, selectReadyBusinessTypes],
  (raw, readyBusinessTypes): IReadyBusinessGroupItemSchema[] => {
    const types = readyBusinessTypes ?? [];
    const hasRental = types.includes(EJsonQueryReadyBusinessType.RentalBusiness);
    const hasReady = types.includes(EJsonQueryReadyBusinessType.ReadyBusiness);

    const groups: IReadyBusinessGroupItemSchema[] = [];

    if (hasRental) {
      groups.push({
        groupType: RENTAL_GROUP_TYPE,
        name: RENTAL_GROUP_NAME,
        items: raw.rentalBusiness.items,
      });
    }

    if (hasReady) {
      groups.push(...raw.readyBusiness.groups);
    }

    return groups;
  },
);
